import { AddedFleetEntry } from "../../../../api/fleet"
import { AddFleetEntryFormError } from "../../types"

// TODO test needed for this

export type FleetEntryCSVUploadState = {
  fileError?: string
  entries: ReadonlyArray<Partial<AddedFleetEntry>>
  errors: ReadonlyArray<AddFleetEntryFormError>
}

export const fleetEntryCSVUploadInitialState = {
  fileError: undefined,
  entries: [],
  errors: [],
}

export type FleetEntryCSVUploadAction =
  | { type: "setFileError"; error: string }
  | { type: "setErrors"; errors: ReadonlyArray<AddFleetEntryFormError> }
  | { type: "setEntries"; entries: ReadonlyArray<Partial<AddedFleetEntry>> }
  | { type: "reset" }

export const fleetEntryCSVUploadReducer = (
  state: FleetEntryCSVUploadState,
  action: FleetEntryCSVUploadAction
): FleetEntryCSVUploadState => {
  switch (action.type) {
    case `setFileError`:
      return {
        ...state,
        fileError: action.error,
      }
    case `setErrors`:
      return {
        ...state,
        errors: action.errors,
      }
    case `setEntries`:
      return {
        ...state,
        entries: action.entries,
      }
    case `reset`:
      return fleetEntryCSVUploadInitialState
    default:
      return state
  }
}
